// Variaveis de ambiente

// URL orquestrador
const urlDefault = 'https://onrhml.forluz.org.br:4000/';
export const baseURL = process.env.REACT_APP_NODE_RED_URL
  ? process.env.REACT_APP_NODE_RED_URL
  : urlDefault;

// URL ws mensageria
const wsMensageriaDefault = 'wss://onrhml.forluz.org.br:4000/ws/mensageria';
export const baseWsMensageria = process.env.REACT_APP_WS_MENSAGERIA
  ? process.env.REACT_APP_WS_MENSAGERIA
  : wsMensageriaDefault;

// ADM
const admDefault = '10.2.103.139';
export const baseADM = process.env.REACT_APP_ADM_URL
  ? process.env.REACT_APP_ADM_URL
  : admDefault;

// CAPTCHA
const recaptchaDefault = '';
export const baseCAPTCHA = process.env.REACT_APP_REQUIRED_RECAPTCHA
  ? process.env.REACT_APP_REQUIRED_RECAPTCHA
  : recaptchaDefault;

// CAPTCHA
const CAPTCHAKEYDefault = '6Lejb94sAAAAAJtUa0oHp-Ga_MD_uh_Z02C-rW6g';
export const baseCAPTCHAKEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY
  ? process.env.REACT_APP_RECAPTCHA_SITE_KEY
  : CAPTCHAKEYDefault;
